import { ModalSuccessBar } from './ModalSuccessBar'
import { ModalSuccessContent } from './ModalSuccessContent'
import { ModalSuccessCustom } from './ModalSuccessCustom'
import { ModalSuccessIcon } from './ModalSuccessIcon'
import { ModalSuccessRoot } from './ModalSuccessRoot'
import { ModalSuccessWrapper } from './ModalSuccessWrapper'

export const ModalSuccess = {
  Bar: ModalSuccessBar,
  Content: ModalSuccessContent,
  Custom: ModalSuccessCustom,
  Icon: ModalSuccessIcon,
  Root: ModalSuccessRoot,
  Wrapper: ModalSuccessWrapper,
}
